import Page from '../../classes/Page';
import carouselsData from "../../carouselData/article";
import createArticleMobileNav from './mobileNav';

const articlePage = new Page({
  name: 'article',
  rootElementId: 'js-article-page',
  carousels: carouselsData,
	resizeDependentMethods: [
		createArticleMobileNav
	]
});

export default articlePage;
